<!-- 品目変更 -->
<script lang="ts">
  import RepositoryFactory, { CONTRACT } from '../../repositories/RepositoryFactory';
  import { isDate, isAfterDay } from '../../components/Util.svelte';
  import { loginUser } from '../../components/auth/LoginUser';
  import Loading from '../../etc/loader.svelte';

  let changeChoiceDate: string;
  let firstChoiceDate: string;
  let secondChoiceDate: string;
  let thirdChoiceDate: string;
  let firstChoiceDateTime: Number;
  let secondChoiceDateTime: Number;
  let thirdChoiceDateTime: Number;
  let firstChoiceDateTimeName: string;
  let secondChoiceDateTimeName: string;
  let thirdChoiceDateTimeName: string;
  let errorMessage: string;
  let isConfirm = false;
  let isComplete = false;
  let isLoading: boolean = false;

  const selectDateTime = [
    { code: 1, name: 'いつでも可能' },
    { code: 2, name: '11〜14時' },
    { code: 3, name: '14〜17時' },
    { code: 4, name: '17〜19時' }
  ];

  // 確認画面
  function onConfirm() {
    // エラーメッセージクリア
    errorMessage = '';
    // 日付フォーマット、翌日以降の日付チェック
    if (!changeChoiceDate) {
      errorMessage = '変更希望日を入力してください。\n';
    } else if (!isDate(changeChoiceDate)) {
      errorMessage = '変更希望日の日付形式が間違っています。\n';
    } else if (!isAfterDay(changeChoiceDate, 6)) {
      errorMessage = '変更希望日は現在日+7日以降の日付を入力してください。\n';
    }

    if (!firstChoiceDate) {
      errorMessage += 'ご連絡希望日1を入力してください。\n';
    } else if (!isDate(firstChoiceDate)) {
      errorMessage += 'ご連絡希望日1の日付形式が間違っています。\n';
    } else if (!isAfterDay(firstChoiceDate)) {
      errorMessage += 'ご連絡希望日1は明日以降の日付を入力してください。\n';
    }

    if (!secondChoiceDate) {
      errorMessage += 'ご連絡希望日2を入力してください。\n';
    } else if (!isDate(secondChoiceDate)) {
      errorMessage += 'ご連絡希望日2の日付形式が間違っています。\n';
    } else if (!isAfterDay(secondChoiceDate)) {
      errorMessage += 'ご連絡希望日2は明日以降の日付を入力してください。\n';
    }

    if (!thirdChoiceDate) {
      errorMessage += 'ご連絡希望日3を入力してください。\n';
    } else if (!isDate(thirdChoiceDate)) {
      errorMessage += 'ご連絡希望日3の日付形式が間違っています。\n';
    } else if (!isAfterDay(thirdChoiceDate)) {
      errorMessage += 'ご連絡希望日3の明日以降の日付を入力してください。\n';
    }

    if (errorMessage) {
      alert(errorMessage);
      return false;
    }

    firstChoiceDateTimeName = selectDateTime.find((v) => v.code === firstChoiceDateTime).name;
    secondChoiceDateTimeName = selectDateTime.find((v) => v.code === secondChoiceDateTime).name;
    thirdChoiceDateTimeName = selectDateTime.find((v) => v.code === thirdChoiceDateTime).name;

    isConfirm = true;
    isComplete = false;
  }
  // 完了画面
  function onComplete() {
    isConfirm = false;
    isComplete = true;
  }
  function onBack() {
    isConfirm = false;
    isComplete = false;
  }
  function doPost() {
    isLoading = true;
    const contractRepository = RepositoryFactory[CONTRACT];
    contractRepository
      .requestQueBacklog({
        processCategoryCode: 'PLAN_CHANGE',
        changeDate: changeChoiceDate,
        changeInfo: null,
        contactDate1: firstChoiceDate + ' ' + firstChoiceDateTimeName,
        contactDate2: secondChoiceDate + ' ' + secondChoiceDateTimeName,
        contactDate3: thirdChoiceDate + ' ' + thirdChoiceDateTimeName
      })
      .then((res) => {
        isLoading = false;
        onComplete();
      })
      .catch((error) => {
        isLoading = false;
        if (error.response.status === 411) {
          alert('入力内容に誤りがあります。再度入力してください。');
        } else if (error.response.status === 403) {
          alert('セッションが切れました。再度ログインしてください。');
          loginUser.logout();
          location.reload();
        } else {
          alert('エラーが発生しました。再度やり直してください。');
        }
      });
  }
</script>

{#if isLoading}
  <Loading />
{/if}

<div class="h-auto p-6 bg-white m-auto max-w-4xl">
  <div class="mb-6">
    <div class="container flex justify-between">
      <h1 class="text-2xl font-bold text-gray-700">品目変更</h1>
    </div>
  </div>

  <div class="shadow rounded-lg bg-gray-50 border-1 p-4">
    <div class="flex flex-col">
      {#if isComplete}
        <div class="flex-1 mb-4">
          <div class="inline-flex justify-items-center items-center min-w-full p-6">
            <span class="">品目変更依頼が完了しました。</span>
          </div>
        </div>
      {:else if isConfirm}
        <div class="flex-1 mb-4">
          <div class="inline-flex justify-items-center items-center min-w-full">
            <div class="">
              下記内容をご確認ください<br />
            </div>
          </div>
        </div>

        <div class="flex-1">
          <div class="inline-grid grid-cols-3 justify-items-center items-center min-w-full">
            <div class="grid-1 justify-self-start w-full">
              <span class="form-label-title">変更希望日：</span>
            </div>
            <div class="grid-1 col-span-2 justify-self-start w-full">
              <span>
                {changeChoiceDate}
              </span>
            </div>
          </div>
        </div>

        <div class="flex-1">
          <div class="inline-grid grid-cols-3 justify-items-center items-center min-w-full">
            <div class="grid-1 justify-self-start w-full">
              <span class="form-label-title">ご連絡希望日1：</span>
            </div>
            <div class="grid-1 col-span-2 justify-self-start w-full">
              <span>
                {firstChoiceDate}
                {firstChoiceDateTimeName}
              </span>
            </div>
          </div>
        </div>

        <div class="flex-1">
          <div class="inline-grid grid-cols-3 justify-items-center items-center min-w-full">
            <div class="grid-1 justify-self-start w-full">
              <span class="form-label-title">ご連絡希望日2：</span>
            </div>
            <div class="grid-1 col-span-2 justify-self-start w-full">
              <span>
                {secondChoiceDate}
                {secondChoiceDateTimeName}
              </span>
            </div>
          </div>
        </div>

        <div class="flex-1 mb-10">
          <div class="inline-grid grid-cols-3 justify-items-center items-center min-w-full">
            <div class="grid-1 justify-self-start w-full">
              <span class="form-label-title">ご連絡希望日3：</span>
            </div>
            <div class="grid-1 col-span-2 justify-self-start w-full">
              <span>
                {thirdChoiceDate}
                {thirdChoiceDateTimeName}
              </span>
            </div>
          </div>
        </div>
      {:else}
        <div class="flex-1 mb-4">
          <div class="min-w-full">
            <div class="text-sm">
              後ほど、カスタマーセンターからご登録のお電話番号へご連絡させていただきます。
              <br />
              各項目をご入力いただき、「手続きへ」を押してください。
            </div>
          </div>
        </div>
        <div class="flex-1 mb-2 pb-2 border-b-2">
          <div class="inline-grid grid-cols-3 justify-items-center items-center min-w-full">
            <div class="grid-1 justify-self-start w-full">
              <span class="form-label-title required">変更希望日</span>
            </div>
            <div class="grid-1 justify-self-start w-full">
              <input type="text" bind:value={changeChoiceDate} placeholder="20210909" />
            </div>
          </div>
        </div>

        <div class="flex-1 mb-2">
          <div class="inline-grid grid-cols-3 justify-items-center items-center min-w-full">
            <div class="grid-1 justify-self-start w-full">
              <span class="form-label-title required">ご連絡希望日1</span>
            </div>
            <div class="grid-1 justify-self-start w-full">
              <input type="text" bind:value={firstChoiceDate} placeholder="20210909" />
            </div>
            <div class="grid-1 justify-self-start w-full">
              <select class="form-select text-sm" bind:value={firstChoiceDateTime} required>
                {#each selectDateTime as time}
                  <option value={time.code}>{time.name}</option>
                {/each}
              </select>
            </div>
          </div>
        </div>

        <div class="flex-1 mb-2">
          <div class="inline-grid grid-cols-3 justify-items-center items-center min-w-full">
            <div class="grid-1 justify-self-start w-full">
              <span class="form-label-title required">ご連絡希望日2</span>
            </div>
            <div class="grid-1 justify-self-start w-full">
              <input type="text" bind:value={secondChoiceDate} placeholder="20210909" />
            </div>
            <div class="grid-1 justify-self-start w-full">
              <div class="grid-1 justify-self-start w-full">
                <select class="form-select text-sm" bind:value={secondChoiceDateTime} required>
                  {#each selectDateTime as time}
                    <option value={time.code}>{time.name}</option>
                  {/each}
                </select>
              </div>
            </div>
          </div>
        </div>

        <div class="flex-1 mb-10">
          <div class="inline-grid grid-cols-3 justify-items-center items-center min-w-full">
            <div class="grid-1 justify-self-start w-full">
              <span class="form-label-title required">ご連絡希望日3</span>
            </div>
            <div class="grid-1 justify-self-start w-full">
              <input type="text" bind:value={thirdChoiceDate} placeholder="20210909" />
            </div>
            <div class="grid-1 justify-self-start w-full">
              <select class="form-select text-sm" bind:value={thirdChoiceDateTime} required>
                {#each selectDateTime as time}
                  <option value={time.code}>{time.name}</option>
                {/each}
              </select>
            </div>
          </div>
        </div>
      {/if}

      <div class="flex-1 mb-10">
        <div class="shadow rounded bg-gray-200 p-4 text-xs">
          <div>
            ※年末年始の休業日、およびビルメンテナンスなどによる休業日があります。
            <br />
            ※変更希望日は工事受付状況等により、ご希望の日程に添えない場合があります。
            <br />
            ※変更希望日は本日を1日目とし、8営業日以降の日付でご指定ください
            <br />
            (営業日とは、土日祝祭日および年末年始を含む大型連休を除く日を指します)
          </div>
          <div class="mt-3">
            ※お問い合わせ状況により、ご連絡に数日お時間を要する場合があります。
            <br />
            ※お問い合わせは以下からご連絡いただきますようお願いいたします。
            <br />
            URL：
            <a href="https://bb.unext.co.jp/contact" rel="noopener noreferrer" target="_blank">
              https://bb.unext.co.jp/contact
            </a>
          </div>
        </div>
      </div>

      {#if isConfirm}
        <div class="flex-1">
          <div class="flex flex-col justify-items-center items-center">
            <div class="flex-1">
              <button on:click|once={onBack} class="button-secondary">戻る</button>
              <button on:click|once={doPost} class="button-primary">完了</button>
            </div>
          </div>
        </div>
      {:else if !isComplete}
        <div class="flex-1">
          <div class="flex flex-col justify-items-center items-center">
            <div class="flex-1">
              <button on:click={onConfirm} class="button-primary">手続きへ</button>
            </div>
          </div>
        </div>
      {/if}
    </div>
  </div>
</div>

<style lang="postcss">
  .form-label-title {
    @apply font-semibold text-gray-700;
  }
  input[type='text'] {
    @apply rounded border py-2 px-3 text-sm placeholder-gray-400 focus:placeholder-gray-200 focus:outline-none focus:ring-2 focus:ring-green-200 focus:border-transparent;
  }
  .button-primary {
    @apply bg-green-400 rounded-lg hover:bg-green-500 focus:outline-none text-sm font-semibold text-white px-10 py-2;
  }
  .button-secondary {
    @apply bg-gray-300 rounded-lg hover:bg-gray-400 text-gray-500 focus:outline-none px-10 py-2;
  }

  .required:after {
    content: ' *';
    color: red;
  }
  .form-select {
    @apply pl-3 pr-10 py-2 transition duration-100 rounded shadow-sm focus:outline-none focus:ring-2 focus:ring-green-200 focus:border-transparent;
  }
  select {
    @apply rounded border py-2 px-3 ml-2 placeholder-gray-400;
  }
</style>
